import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { reduxForm } from 'redux-form'
import { destroy, put } from '../modules/type'

import component from 'components/Types/Edit'

const mapActionCreators = {
  onSubmit: put,
  handleDelete: destroy // NOTE: this cannot be named destroy as reduxForm uses that..
}

const mapDispatchToProps = (dispatch) => ({
  ...bindActionCreators(mapActionCreators, dispatch),
  dispatch
})

const mapStateToProps = (state) => {
  let obj = {
    type: state.type,
    options: state.options,
    uoms: state.uoms,
    initialValues: Object.assign({}, {
      options: [{ id: undefined }],
      uoms: [{ id: undefined }]
    }, state.type)
  }

  obj.initialValues.options = obj.initialValues.options.filter(o => o && o.id)
  obj.initialValues.options.push({ id: undefined })

  obj.initialValues.uoms = obj.initialValues.uoms.filter(o => o && o.id)
  obj.initialValues.uoms.push({ id: undefined })

  return obj
}

const form = reduxForm({
  form: 'edit-type',
  fields: ['id', 'name', 'report', 'constrain_options_to_pricelist', 'bin_max', 'bin_uom_id', 'options[].id', 'uoms[].id'],
  touchOnChange: true,
  validate (state) {
    var errors = {}
    if (!state.name) errors.name = 'Please enter a name.'

    return errors
  }
})(component)

export default connect(mapStateToProps, mapDispatchToProps)(form)



// WEBPACK FOOTER //
// ./src/routes/Types/containers/EditTypeContainer.js